<script>
    import { onMount } from "svelte";

    import { apiMethods } from "../../Services/index.svelte";

    import {
        PageHead,
        PageLoading,
    } from "../../Components/Common/index.svelte";

    import { isMobile } from "../../stores";
    import {
        showError,
        showException,
        sortEnumAlphabetically,
    } from "../../Utils/utilFunctions.svelte";
    import CardLayout from "../../Components/Common/CardLayout.svelte";

    export let params = {};

    let isLoading = false,
        asaKeys = [],
        asaData = {};

    onMount(() => {
        if (params.id) getASAItemById(params.id);
    });

    const getASAItemById = async (id) => {
        isLoading = true;

        await apiMethods.getMethod
            .getASAItemByItemId(id)
            .then((res) => {
                if (res.error) showError(res.error);
                else {
                    asaData = { ...res };
                    if (asaData.description) {
                        const descCon = asaData.description;
                        delete asaData.description;
                        asaData.description = descCon;
                    }
                    asaKeys = Object.keys(asaData);
                }
            })
            .catch((err) => showException(err));

        isLoading = false;
    };

    const getDisplayKey = (key) => `${key}:`;

    // HELPER FUNCTIONS
</script>

{#if isLoading}
    <PageLoading />
{:else}
    <div class="flex flex-col gap-2">
        <PageHead title="View ASA Item" />
        <CardLayout title="ASA Item Details">
            <div
                class="flex-1 px-2 py-4 w-full {$isMobile
                    ? 'flex flex-col gap-y-2'
                    : 'grid-cols-3 gap-3 grid grid-flow-row-dense'}"
            >
                <div class="flex col-span-3 font-bold">
                    {asaData["description"]}
                </div>
                <div class="flex flex-col gap-y-1 col-span-3">
                    <p class="w-48 capitalize">
                        {getDisplayKey("id")}
                        {asaData["id"]}
                    </p>
                </div>
                {#each asaKeys
                    .filter((key) => key != "description" && key != "id")
                    .sort( (a, b) => sortEnumAlphabetically(a, b), ) as key}
                    <div class="flex flex-row col-span-1">
                        <p class="w-auto capitalize">
                            {getDisplayKey(key)}
                        </p>
                        <p class="w-auto ml-3">{asaData[key]}</p>
                    </div>
                {/each}
            </div>
        </CardLayout>
    </div>
{/if}
